import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Pet } from 'src/app/interfaces/pet';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { UserService } from 'src/app/services/user/user.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { CloudinaryService } from 'src/app/services/cloudinary/cloudinary.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-unauthenticated-header',
  templateUrl: './unauthenticated-header.component.html',
  styleUrls: ['./unauthenticated-header.component.scss'],
})
export class UnauthenticatedHeaderComponent implements OnInit, OnDestroy {
  isBrowser: boolean;

  public displayOnlyUserIconDropdown: boolean = true;
  private _subs: Subscription[] = [];

  constructor(
    public authManager: AuthManagerService,
    private userService: UserService,
    private breakpointObserver: BreakpointObserver,
    private cloudinaryService: CloudinaryService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  get pets(): Pet[] {
    return this.userService.user
      ? this.userService.filterAliveRegisteredPets(this.userService.user.pets)
      : [];
  }

  ngOnInit(): void {
    this.handleHeaderElementVisibility();
  }

  ngOnDestroy(): void {
    this._subs.forEach((it) => it.unsubscribe());
  }

  opened(isOpened: boolean): void {
    if (this.isBrowser && isOpened) {
      window.analytics.track('header::menu::opened');
    }
  }

  public getPetImageUrl(petImageId: string): string {
    return this.cloudinaryService.getImageUrl(petImageId, 88, 88, null);
  }

  private handleHeaderElementVisibility() {
    this._subs.push(
      this.breakpointObserver
        .observe(['(min-width: 800px)'])
        .subscribe((state: BreakpointState) => {
          if (state.matches) {
            this.displayOnlyUserIconDropdown = false;
          } else {
            this.displayOnlyUserIconDropdown = true;
          }
        })
    );
  }
}
